import { combineReducers } from 'redux';

import BasketReducer from './basket';

export default combineReducers({
    basket: BasketReducer,
});
